// ==============================|| OVERRIDES - APPBAR ||============================== //

export default function AppBar(theme) {
	return {
		MuiAppBar: {
			styleOverrides: {
				colorPrimary: {
					backgroundColor: "white",
				},
			},
		},
	};
}
